<script setup lang="ts">
import { Enums } from "@/enums";
import { computed } from "vue";
import { assertUnhandledStatus } from "../../common/asserts.common";

const props = defineProps<{
    status: Enums.DismantleStatusEnum.Values;
}>();

const label = computed(() => Enums.DismantleStatusEnum.label(props.status));
const color = computed(() => {
    switch (props.status) {
        case "W":
            return "bg-gray-500";
        case "DI":
            return "bg-sky-500";
        case "F":
            return "bg-purple-500";
        case "D":
            return "bg-green-500";
        case "C":
            return "bg-red-500";
        default:
            return assertUnhandledStatus(props.status);
    }
});
</script>

<template>
    <div class="rns-g-badge" :class="color">{{ label }}</div>
</template>

<style>
@reference "@/styles/main.css";
</style>
